import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { useGetAllConversationsQuery } from '../../../app/Slices/SevenDayApiSlice';
import ReportLoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/ReportLoadingComponent';
import AIHistoryTable from '../../components/Reservations/AIReservations/AIHistoryTable';
import SearchFilter from '../../shared/SearchFilter';

export default function AiHistoryPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');

    const { data: conversations, isFetching } = useGetAllConversationsQuery({});

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Grid
                sx={{ width: '100%', justifyContent: 'left', display: 'flex' }}
            >
                <Typography
                    variant='h1'
                    sx={{
                        textAlign: 'left',
                        textTransform: 'uppercase',
                    }}
                >
                    AI History
                </Typography>
            </Grid>

            <Grid
                sx={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-end',
                    paddingTop: 2,
                }}
            >
                <SearchFilter />
            </Grid>

            <Grid
                sx={{
                    width: '100%',
                    justifyContent: isMobile ? 'center' : 'left',
                    alignItems: isMobile ? 'center' : 'left',
                }}
            >
                <Box
                    sx={{
                        height: isFetching ? 500 : '100%',
                        width: '100%',
                        paddingTop: '24px',
                        overflowX: 'auto',
                    }}
                >
                    <Divider />
                    {isFetching ? (
                        <ReportLoadingComponent />
                    ) : (
                        <AIHistoryTable conversations={conversations} />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
}
